/*
 * Polly Pocket PDP doll — GSAP-driven motion.
 * Loaded only on Polly product pages, after gsap.min.js (both deferred, so order is guaranteed).
 * The CSS in section-main-product.css provides a no-JS fallback (peek, sway, hop);
 * adding .is-gsap to the doll switches that off so GSAP owns the transforms.
 */
(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (typeof gsap === 'undefined') return;

  var BASE_ROTATION = -12;   // matches the static tilt in the CSS
  var LEAN_RANGE = 6;        // degrees of extra tilt toward the pointer
  var rem = parseFloat(getComputedStyle(document.documentElement).fontSize) || 10;

  document.querySelectorAll('.product__details .polly-pocket-doll').forEach(initDoll);

  function initDoll(doll) {
    var figure = doll.querySelector('.polly-pocket-doll__figure');
    var details = doll.closest('.product__details');
    if (!figure || !details) return;


    var baseRotation = doll.closest('.main-product-info[data-handle="pistachio-swirl"]') ? 12 : BASE_ROTATION;

    // Take over from the CSS animations. Class add and gsap.set run in the same tick,
    // so the doll never paints at rest before sliding in.
    doll.classList.add('is-gsap');
    gsap.set(doll, { xPercent: 130, transformOrigin: '50% 100%' });
    gsap.set(figure, { rotation: baseRotation, transformOrigin: '50% 100%' }); // pivot at her feet, matches the CSS

    // 1. Peek in from the edge, then 2. settle into a slow idle sway.
    gsap.timeline({ delay: 0.4 })
      .to(doll, { xPercent: 0, duration: 0.9, ease: 'back.out(1.6)' })
      .fromTo(doll,
        { rotation: -2.5 },
        { rotation: 2.5, duration: 2, ease: 'sine.inOut', yoyo: true, repeat: -1 });

    // Keeping only the peek-in and idle sway for now.
    // Pointer-driven lean and the squash-and-stretch hop are parked below.
    /*
    // 3. Lean toward the pointer as it moves around the product details.
    var leanRotation = gsap.quickTo(figure, 'rotation', { duration: 0.5, ease: 'power2.out' });
    var leanX = gsap.quickTo(figure, 'x', { duration: 0.5, ease: 'power2.out' });

    details.addEventListener('pointermove', function (e) {
      if (e.pointerType && e.pointerType !== 'mouse') return;
      var box = doll.getBoundingClientRect();
      var centerX = box.left + box.width / 2;
      var dx = gsap.utils.clamp(-1, 1, (e.clientX - centerX) / (details.clientWidth * 0.6));
      leanRotation(BASE_ROTATION + dx * LEAN_RANGE);
      leanX(Math.min(dx, 0) * 0.4 * rem); // only shuffle left; she is flush with the right edge
    });

    details.addEventListener('pointerleave', function () {
      leanRotation(BASE_ROTATION);
      leanX(0);
    });

    // 4. Squash-and-stretch hop when the pointer enters the details column.
    var hop = null;
    details.addEventListener('pointerenter', function (e) {
      if (e.pointerType && e.pointerType !== 'mouse') return;
      if (hop && hop.isActive()) return;
      hop = gsap.timeline()
        .to(figure, { scaleY: 0.92, scaleX: 1.06, y: 0, duration: 0.12, ease: 'power2.out' })
        .to(figure, { scaleY: 1.05, scaleX: 0.97, y: -0.7 * rem, duration: 0.22, ease: 'power2.out' })
        .to(figure, { scaleY: 0.95, scaleX: 1.04, y: 0, duration: 0.2, ease: 'power2.in' })
        .to(figure, { scaleY: 1, scaleX: 1, y: 0, duration: 0.35, ease: 'elastic.out(1, 0.5)' });
    });
    */
  }
})();
